// Section registry, in v2's top-to-bottom order (after the hero, trust strip and deals, which App renders).
import type * as React from 'react'

import type { Model } from '../types'
import { Types, Categories, Colors, Mini } from './Browse'
import { Size, Exact, Best, Fridges } from './Sizes'
import { Freezers, Upright, Rooms, Spaces } from './Freezers'
import { Specialty, Fun, Rails, Commercial, ApartmentRail } from './Specialty'
import { Brands, Parts } from './BrandsParts'
import { Intel, Overpay, Quiz, Tools } from './Intel'
import { Local, Faq, Wiki, Ids, Guides } from './Learn'
import { Social, Searches, About, Promise, Alerts, Footer } from './Community'
import { SideBySide } from './SideBySide'
import { BeforeParts, BeforeTools, BeforeFaq, BeforeSocial } from './Discovery'

type S = { key: string; C: React.ComponentType<{ model: Model }> }

export const SECTIONS: S[] = [
  { key: 'Types', C: Types },
  { key: 'Categories', C: Categories },
  { key: 'Colors', C: Colors },
  { key: 'Mini', C: Mini },
  { key: 'Size', C: Size },
  { key: 'ApartmentRail', C: ApartmentRail },
  { key: 'Exact', C: Exact },
  { key: 'Best', C: Best },
  { key: 'Fridges', C: Fridges },
  { key: 'Freezers', C: Freezers },
  { key: 'Upright', C: Upright },
  { key: 'Rooms', C: Rooms },
  { key: 'Spaces', C: Spaces },
  { key: 'Specialty', C: Specialty },
  { key: 'Fun', C: Fun },
  { key: 'Rails', C: Rails },
  { key: 'Commercial', C: Commercial },
  { key: 'Brands', C: Brands },
  { key: 'BeforeParts', C: BeforeParts },
  { key: 'Parts', C: Parts },
  { key: 'Intel', C: Intel },
  { key: 'Overpay', C: Overpay },
  { key: 'Quiz', C: Quiz },
  { key: 'BeforeTools', C: BeforeTools },
  { key: 'Tools', C: Tools },
  { key: 'Local', C: Local },
  { key: 'BeforeFaq', C: BeforeFaq },
  { key: 'Faq', C: Faq },
  { key: 'Wiki', C: Wiki },
  { key: 'Ids', C: Ids },
  { key: 'Guides', C: Guides },
  { key: 'BeforeSocial', C: BeforeSocial },
  { key: 'Social', C: Social },
  { key: 'Searches', C: Searches },
  { key: 'SideBySide', C: SideBySide },
  { key: 'About', C: About },
  { key: 'Promise', C: Promise },
  { key: 'Alerts', C: Alerts },
]

export const SECTIONS_FOOTER: S = { key: 'Footer', C: Footer }
